var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M12 0V24",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M0 12H24",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqPlus);
export default __webpack_public_path__ + "static/media/faq_plus.ad3128118b97c1df880545c34907689f.svg";
export { ForwardRef as ReactComponent };